import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { TransactionSkeleton } from '@/components/LoadingSkeletons/TransactionSkeleton'
import { useTheme } from '@/hooks/useTheme'

interface EmptyTransactionProps {
  isLoadingTransactions?: boolean
}

export const EmptyTransaction: React.FC<EmptyTransactionProps> = ({
  isLoadingTransactions = false,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  if (isLoadingTransactions) {
    return (
      <TransactionSkeleton
        count={3}
        containerStyles={{
          paddingLeft: '12px',
          paddingRight: '12px',
        }}
      />
    )
  }

  return (
    <BaseView
      center
      py={40}
      px={20}
      style={{
        minHeight: '200px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <BaseText
        fontSize={16}
        fontFamily="regular"
        color="label.default"
        style={{
          textAlign: 'center',
          opacity: 0.7,
        }}
      >
        {t('translation:transactionsNotFound') || 'No transactions found'}
      </BaseText>
    </BaseView>
  )
}
